import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRODUCT_SET_IMAGE } from '../data/productImages';

/** Live checkout. */
const CHECKOUT_URL = 'https://memory-care-activity-ready.impultienda.ar/checkout';
const included = ['6 volumes · 90 three-way activities', '5 instant-use bonuses', '300 landscape pages, print or phone', '15, 30 and 45-minute sessions + a 10-minute 1:1 visit', '48 planning worksheets', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-blush text-ink" data-id="element-190" data-mp="25s7ub4mycpzc">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-191" data-mp="20slhgwb1dbr2">
        <div className="text-center" data-id="element-192" data-mp="20vhgknyme6h3">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-193" data-mp="3h6lfg1qbmrbo">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold text-plum text-3xl sm:text-5xl" data-id="element-194" data-mp="3c7s3idqon8dm">
            Everything you need to run{' '}
            <span className="italic" data-id="element-195" data-mp="4rugf94nzu5c">every activity three ways</span>
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-blush-dark bg-white shadow-card" data-id="element-196" data-mp="9tjukxn6onxn">
          <div className="bg-plum px-5 py-5 text-center" data-id="element-197" data-mp="eqtha5j6ulhs">
            <h3 className="font-display text-xl font-bold text-white sm:text-2xl" data-id="element-198" data-mp="3d9h8nhogug19">
              Memory Care Activity Ready — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-semibold text-gold-hover" data-id="element-199" data-mp="3i5xwearr6sdt">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-200" data-mp="3rydfxcip7p0t">
            <img src={PRODUCT_SET_IMAGE} alt="All six Memory Care Activity Ready volumes side by side" width={1024} height={688} loading="lazy" className="mx-auto aspect-[1024/688] w-full max-w-lg rounded-2xl border border-cream-line object-cover" data-id="element-201" data-mp="3rzeo998bxxeu" />

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-202" data-mp="2mi1k1eyxhtae">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-203" data-mp="3177ih0pxzfh8">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/25" data-id="element-204" data-mp="318ipd9eop3ck">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-205" data-mp="28hh54tw4whm6" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cream-dark pt-6 text-center" data-id="element-206" data-mp="2ie3kx49lsihc">
              <div className="flex items-start justify-center gap-1 text-plum" data-id="element-207" data-mp="2dfim99a026v0">
                <span className="mt-2.5 font-display text-3xl" data-id="element-208" data-mp="3tuagzsumbq7h">$</span>
                <span className="font-display font-bold text-6xl leading-[0.9] sm:text-7xl" data-id="element-209" data-mp="3owiksmmxxhxh">
                  27
                </span>
                <span className="mt-3 text-[13px] font-semibold text-ink-muted" data-id="element-210" data-mp="9m28g6nvqa5">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-211" data-mp="3nf37kwrzm7y1">
                <span className="rounded-full border border-gold bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-gold-ink" data-id="element-212" data-mp="3ngwi4n5q1cbb">
                  One-time payment
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-213" data-mp="j2y8rtg058fy">
                  No subscription
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-214" data-mp="a6qoeg0iblqy">
                  Instant download
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL || '#pricing'} className="mt-5" data-id="element-215" data-mp="16q7k5n3xqj2z">
                Get Memory Care Activity Ready — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-soft" data-id="element-216" data-mp="3f5fjmsqq6j4j">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-217" data-mp="3592pxuv6k59s">
                <li className="flex items-center gap-1.5" data-id="element-218" data-mp="318ixh4ljxptz">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-219" data-mp="31a3s0u7v98ru" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-220" data-mp="3t19jyndfo061">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-221" data-mp="3o6vvl4x6utav" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-222" data-mp="kjwyvf6t6231">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-223" data-mp="fsn8gcdfquq3" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-soft" data-id="element-224" data-mp="23gc7w9dtvf55">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}